import React, { Component } from "react"
import { connect } from "react-redux"
import styles from "./styles.css"
import Card from "../../../components/Card"
import LabeledValue from "../../../components/LabeledValue"
import SectionSeparator from "../../../components/SectionSeparator"
import _ from "lodash"
import * as utils from "../../../utils"
import * as strings from "../../../strings"
import DebtPhasesTable from "../DebtPhasesTable"


class ValidateBillingOrder extends Component {
  props: {
    value: any,
    onChange: any,

    clients: any,
  }

  render () {
    const { billingPhase, debtPhase, clientName, debtPhases } = this.props.value
    const expenseTotalValue = _.chain( debtPhases )
      .flatMap( debtPhase => debtPhase.expenses )
      .map( expense => parseFloat( expense.value ) )
      .sum()
      .thru( utils.formatCurrency )
      .value()

    return (
      <Card className={styles.root}>
        <div className={styles.detailsRow}>
          <LabeledValue big label={strings.generalStrings.billingPhase}>
            {strings.BillingPhaseTranslation[ billingPhase ]}
          </LabeledValue>
          <LabeledValue big label={strings.processes.processPhase}>
            {strings.DebtPhaseTranslation[ debtPhase ]}
          </LabeledValue>
          <LabeledValue big label={strings.generalStrings.company}>
            {clientName}
          </LabeledValue>
        </div>
        <SectionSeparator title={strings.generalStrings.expenses} />
        <div className={styles.expenses}>
          <DebtPhasesTable debtPhases={debtPhases} />
        </div>
        <div className={styles.expensesTally}>
          <LabeledValue big label={strings.generalStrings.value}>
            {expenseTotalValue}
          </LabeledValue>
        </div>
      </Card>
    )
  }
}

export default connect( ( store ) => ( {
  clients: _.get( store, "suggestions.clients", [] ),
} ) )( ValidateBillingOrder )



// WEBPACK FOOTER //
// ./src/views/CreateBillingOrder/Validate/index.jsx